/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Popover, Tooltip, IconButton } from "@mineral/core";
import { SearchIcon as Search } from "../ui-components/uim-components";
import SearchField from "./../inventory/InventorySearch";
import "./titleBarAccount.less";
import Resource from "./Resource";

class InventorySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSearch: false,
      anchorEl: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.location !== nextProps.location) {
      this.setState({
        showSearch: false,
      });
    }
  }
  // onKeyUp = (evt) => {
  //   //close filter when user presses esc key or enter key
  //   console.log(evt);
  //   if (evt.which === 27 || evt.which === 13) {
  //     this.handleRequestClose();
  //   }
  // };
  handleTouchTap = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      showSearch: true,
      anchorEl: event.currentTarget,
    });
  };
  handleRequestClose = () => {
    this.setState({
      showSearch: false,
      anchorEl: null,
    });
    ReactDOM.findDOMNode(this.searchButton).focus();
    this.props.setQuickFilter();
  };
  render() {
    //Search For Computer Systems
    const helplabelmessage = Resource.get("Search For Computer Systems");
    return (
      <span>
      <Tooltip title={helplabelmessage}>
        <IconButton
          id="search-icon-main-button"
          className="search__icon"
          title={helplabelmessage}
          onClick={this.handleTouchTap}
          ref={(button) => (this.searchButton = button)}
        >
          <Search title={helplabelmessage} />
        </IconButton>
        </Tooltip>
        <Popover
          className="inventorySearch__popover"
          open={this.state.showSearch}
          anchorEl={this.state.anchorEl}
          onClose={this.handleRequestClose}
        >
          <SearchField screenReaderLabel={helplabelmessage}
            onKeyUp={this.onKeyUp}
            setSearchTerm={(value) => {
              this.props.setSearchTerm(value);
              this.handleRequestClose();
            }}
          />
        </Popover>
      </span>
    );
  }
}

export default InventorySearch;
